export default __webpack_public_path__ + "static/media/TVinsure-Benefit-of-Insurance-home.6ced808b.png";